import type { WithdrawalPaymentFile } from '../models';

/** Forma cruda que devuelve la API (nombres en singular u opcionales) */
export type WithdrawalPaymentFileApi = Omit<WithdrawalPaymentFile, 'withdrawals_count' | 'created_at' | 'filename'> & {
  withdrawals_count?: number;
  withdrawal_count?: number;
  original_filename?: string | null;
  created_at?: string;
  filename?: string | null;
};

/** Normaliza un fichero de pago de la API al modelo del frontend */
export const normalizeWithdrawalPaymentFile = (item: WithdrawalPaymentFileApi): WithdrawalPaymentFile => ({
  ...item,
  withdrawals_count: item.withdrawals_count ?? item.withdrawal_count ?? 0,
  filename: item.filename ?? item.original_filename ?? null,
  created_at: item.created_at ?? '',
});
